import { useState } from 'react';

import type { JobCard } from '../fixtures/domain.js';
import { Avatar } from '../components/Avatar.js';
import { Icon } from '../components/Icon.js';
import { JobDetailsDialog } from './JobDetailsDialog.js';
import styles from './JobMessageCard.module.css';

/** The board's listing card at the foot of a bubble; View details opens the full posting. */
export function JobMessageCard({ job }: { job: JobCard }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.card}>
      <div className={styles.kind}>
        <Icon name="briefcase" size={14} />
        Job posting
      </div>
      <div className={styles.body}>
        <div className={styles.head}>
          {job.company && <Avatar name={job.company.name} src={job.company.logoUrl} size={40} />}
          <div className={styles.headText}>
            <span className={styles.title}>{job.title}</span>
            {job.company && (
              <span className={styles.company}>
                <span className={styles.companyName}>{job.company.name}</span>
                {job.company.verified && (
                  <span className={styles.verified} title="Verified employer">
                    <span className={styles.srOnly}>Verified employer</span>
                    <Icon name="verified" size={16} />
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
        {job.salary && (
          <span className={styles.salary}>
            <Icon name="money" size={22} />
            <span className={styles.srOnly}>Salary: </span>
            {job.salary}
          </span>
        )}
        <span className={styles.fact}>
          <Icon name="businessCenter" size={22} />
          <span className={styles.srOnly}>Job type: </span>
          {job.jobType}
        </span>
        {job.location && (
          <span className={styles.fact}>
            <Icon name="place" size={22} />
            <span className={styles.srOnly}>Location: </span>
            {job.location}
          </span>
        )}
      </div>
      <button type="button" className={styles.foot} onClick={() => setOpen(true)}>
        View details
      </button>
      {open && (
        <JobDetailsDialog
          job={{
            jobTitle: job.title,
            jobType: job.jobType,
            ...(job.location ? { jobLocation: job.location } : {}),
            ...(job.description ? { description: job.description } : {}),
            ...(job.responsibilities ? { responsibilities: job.responsibilities } : {}),
            ...(job.requirements ? { requirements: job.requirements } : {}),
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
